import { toDate } from 'date-fns-tz';
import { Route } from 'vue-router';

type ParamType = StringConstructor | BooleanConstructor | NumberConstructor | DateConstructor;
type Primitive = string | number | boolean | Date

const DATE_REGEXP = /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;

function determineType (value: string) {
  if (/^\d+(\.\d+)?$/.test(value)) return Number;
  else if (/^(false|true)$/.test(value)) return Boolean;
  else if (DATE_REGEXP.test(value)) return Date;
  else return String;
}

function parseValueByType (value: string, type: ParamType | [ParamType]): any {
  if (Array.isArray(type)) {
    return value.split(',').map(val => parseValueByType(val, type[0]));
  }

  switch (type) {
    case String:
      return value;
    case Boolean:
      return value === 'true';
    case Number:
      if (/^\d+\.\d+/.test(value)) {
        return parseFloat(value);
      } else {
        return parseInt(value);
      }
    case Date:
      return toDate(value, { timeZone: 'Europe/Paris' });
    default:
      return value;
  }
}

export function parseRouteParams (route: Route, paramsTypes: { [key: string]: ParamType | [ParamType] } = {}): Record<string, Primitive | Primitive[]> {
  const params: Record<string, Primitive | Primitive[]> = {};

  const props = (route.matched[route.matched.length - 1].components.default as any).options.props;

  const routeParams = Object.assign({}, route.params, route.query);

  for (const key in routeParams) {
    const value = routeParams[key];
    let type = paramsTypes[key] || props[key]?.type || null;

    if (Array.isArray(type)) { // props type = [Class1, Class2, ...]
      const _type = determineType(value);
      if (type.includes(_type)) {
        type = _type;
      } else {
        type = null;
      }
    }

    if (type === Array) { // props type = Class[]
      type = [determineType(value.split(',')[0])];
    }

    if (type === null) { // undefined type, string by default
      type = String;
    }

    params[key] = parseValueByType(value, type);
  }
  return params;
}

export function buildUrlParamIdLibelle (id: number, libelle: string): string;
export function buildUrlParamIdLibelle (obj: { id: number, libelle: string }): string;
export function buildUrlParamIdLibelle (arg1: number | { id: number, libelle: string }, arg2?: string): string {
  let id;
  let libelle;

  if (typeof arg1 === 'number') {
    id = arg1;
    libelle = arg2;
  } else {
    ({ id, libelle } = arg1);
  }

  return `${id}-${libelle.replace(/ /g, '_')}`;
}
